import { render, staticRenderFns } from "./Horeca.vue?vue&type=template&id=403db98f&"
import script from "./Horeca.vue?vue&type=script&lang=js&"
export * from "./Horeca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports